import { lazy, Suspense } from "react";
import { Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/common/ProtectedRoute";
import PageLoader from "../components/common/PageLoader";

const SellerLayout = lazy(() => import("../components/seller/SellerLayout"));
const SellerDashboard = lazy(() => import("../components/pages/seller/SellerDashboard"));
const SellerProducts = lazy(() => import("../components/pages/seller/SellerProducts"));
const SellerOrders = lazy(() => import("../components/pages/seller/SellerOrders"));
const SellerProfile = lazy(() => import("../components/pages/seller/SellerProfile"));
const SellerCustomers = lazy(() => import("../components/pages/seller/SellerCustomers"));
const SellerReviews = lazy(() => import("../components/pages/seller/SellerReviews"));
const SellerPayments = lazy(() => import("../components/pages/seller/SellerPayments"));
const SellerOffers = lazy(() => import("../components/pages/seller/SellerOffers"));
const SellerAnalytics = lazy(() => import("../components/pages/seller/SellerAnalytics"));
const SellerSettings = lazy(() => import("../components/pages/seller/SellerSettings"));

const SellerRoutes = () => (
  <>
    <Route
      path="/seller"
      element={
        <ProtectedRoute allowedRoles={["seller"]}>
          <Suspense fallback={<PageLoader />}>
            <SellerLayout />
          </Suspense>
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="/seller/dashboard" replace />} />
      <Route path="dashboard" element={<SellerDashboard />} />
      <Route path="products" element={<SellerProducts />} />
      <Route path="orders" element={<SellerOrders />} />
      <Route path="profile" element={<SellerProfile />} />
      <Route path="customers" element={<SellerCustomers />} />
      <Route path="reviews" element={<SellerReviews />} />
      <Route path="payments" element={<SellerPayments />} />
      <Route path="offers" element={<SellerOffers />} />
      <Route path="analytics" element={<SellerAnalytics />} />
      <Route path="settings" element={<SellerSettings />} />
    </Route>

    {/* Seller status pages */}
    <Route
      path="/seller/pending"
      element={
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className="text-center p-8 bg-yellow-50 rounded-lg shadow-md">
            <div className="text-6xl mb-4">⏳</div>
            <h1 className="text-2xl font-bold text-yellow-600">Store Under Review</h1>
            <p className="text-gray-600 mt-2">
              Your store is pending approval. You'll receive an email once verified.
            </p>
          </div>
        </div>
      }
    />
    <Route
      path="/seller/rejected"
      element={
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className="text-center p-8 bg-red-50 rounded-lg shadow-md">
            <div className="text-6xl mb-4">❌</div>
            <h1 className="text-2xl font-bold text-red-600">Store Application Rejected</h1>
            <p className="text-gray-600 mt-2">
              Your store application has been rejected. Please contact support.
            </p>
          </div>
        </div>
      }
    />
  </>
);

export default SellerRoutes;
